import { prop } from 'ramda';
import { useCallback } from 'react';
import { usePaymentsSelector } from 'js/store/hooks';

export const useGetBeforeWithdrawHandler = () => {
    const beforeWithdrawHooks = usePaymentsSelector(prop('beforeWithdrawHooks'));

    return useCallback(async ({ specificParams }: { specificParams: Record<string, any> }) => {
        let promise = Promise.resolve({ specificParams });

        for (const hook of beforeWithdrawHooks) {
            promise = promise.then((...args) => hook(...args));
        }

        return await promise;
    }, [beforeWithdrawHooks]);
};
